<script>
import { VDataTable } from 'vuetify/lib'

export default {
    extends: VDataTable,
    props: {
        'disable-sort': {
            default: true,
        },
        'multi-sort': {
            default: true,
        },
        'item-key': {
            default: 'id',
        },
        footerProps: {
            default: () => {
                return {
                    itemsPerPageOptions: [15],
                    showFirstLastPage: true,
                };
            }
        }
    },
    watch: {
        itemsPerPage(value) {
            this.$props.footerProps.itemsPerPageOptions = [value];
        }
    },
}
</script>
